import { render, staticRenderFns } from "./gravies.vue?vue&type=template&id=796a06f0&scoped=true"
import script from "./gravies.vue?vue&type=script&lang=js"
export * from "./gravies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a06f0",
  null
  
)

export default component.exports